import React from "react";
import styled from "styled-components";
import { color, font, shadow } from "../tokens";
import {
  Inner,
  MonoLabel,
  Reveal,
  SectionRow,
  RowMeta,
  TwoTone,
} from "../primitives";
import AnimatedIcon from "../icons";
import teamOrchestrator from "../../images/team-orchestrator.webp";

const Wrap = styled.div`
  padding-bottom: clamp(120px, 22vh, 240px);
`;

const Rule = styled.div`
  height: 1px;
  background: ${color.line};
  margin-bottom: clamp(24px, 4vh, 44px);
`;

const LabelStack = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Card = styled.div`
  margin-top: clamp(40px, 7vh, 80px);
  background: ${color.pastel.sky};
  border-radius: 18px;
  padding: clamp(24px, 3.5vw, 44px);
  box-shadow: ${shadow.card};
`;

const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`;

const CardTitle = styled.h3`
  margin: 0 0 6px;
  font-family: ${font.display};
  font-size: clamp(26px, 3.2vw, 44px);
  font-weight: 400;
  letter-spacing: 0.01em;
  text-transform: uppercase;
`;

const CardCopy = styled.p`
  margin: 0 0 22px;
  font-family: ${font.body};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  max-width: 58ch;
  color: rgba(14, 14, 12, 0.82);
  text-wrap: pretty;
`;

const Shot = styled.div`
  border-radius: 10px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
  }
`;

/** Ongoing R&D — after-hours projects, currently the team orchestrator. */
const RnDSection: React.FC = () => (
  <Wrap id="rnd">
    <Inner>
      <Reveal>
        <Rule />
        <SectionRow>
          <LabelStack>
            <AnimatedIcon name="flask" size={15} strokeWidth={2} />
            <MonoLabel as="h2" style={{ margin: 0 }}>
              Ongoing R&D
            </MonoLabel>
          </LabelStack>
          <TwoTone
            ink="What I'm building after hours."
            muted="Research projects that feed back into client work."
          />
          <RowMeta>
            <MonoLabel>2026 · WIP</MonoLabel>
          </RowMeta>
        </SectionRow>
      </Reveal>
      <Reveal delay={0.1}>
        <Card>
          <CardHead>
            <MonoLabel>R&D-2026 · 01</MonoLabel>
            <AnimatedIcon name="sparkles" size={18} strokeWidth={1.8} />
          </CardHead>
          <CardTitle>Team Orchestrator</CardTitle>
          <CardCopy>
            A multi-agent development environment — a team of coding agents
            planning, delegating and reviewing work across a shared board,
            building on the agentic patterns from Vista.
          </CardCopy>
          <Shot>
            <img
              src={teamOrchestrator}
              alt="Team orchestrator interface"
              loading="lazy"
            />
          </Shot>
        </Card>
      </Reveal>
    </Inner>
  </Wrap>
);

export default RnDSection;
